<template>
  <div class="courses-wrapper">
    <basis-nav
      nav-title="课程详情"
      :back="back"
    />
    <template v-if="loading">
      <van-skeleton avatar />
      <van-skeleton title :row="3" />
    </template>
    <template v-else>
      <basis-copy-book-card
        avatar-key="cover"
        :item="course"
        :target-item="course.teacher"
      >
        <template v-slot:title="{item}">
          {{ item.name }}
        </template>
        <template v-slot:target="{target}">
          老师：{{ target.name }}
        </template>
      </basis-copy-book-card>
      <van-tabs
        v-if="!isRefresh"
        v-model="activeTab"
        sticky
      >
        <template v-for="tagName in tags">
          <van-tab :key="tagName" :title="tagOptions[tagName].title" :name="tagName">
            <div :class="['wrapper', tagName]">
              <template v-if="tagName === 'characters'">
                <div class="characters-features-wrapper">
                  <form action="#" class="search-form">
                    <van-search
                      v-model="kw"
                      class="search-field"
                      placeholder="请输入"
                      @search="onSearch"
                    >
                      <template v-slot:left-icon>
                        <van-icon name="search" class="icon-search" />
                      </template>
                    </van-search>
                  </form>
                  <van-checkbox
                    v-model="onlyVideo"
                    icon-size="14px"
                    checked-color="#E6AF6C"
                    label-position="left"
                    class="toggole-button"
                  >
                    <span :class="['text', {'is-active': onlyVideo}]">有视频</span>
                  </van-checkbox>
                </div>
              </template>
              <basis-list-wrapper
                :target-key="tagName"
                :extra-keys="extraKeys"
                :per-page="tagName === 'characters' ? 20 : 10"
              >
                <template v-slot:item="{item}">
                  <component
                    :is="tagOptions[tagName].componentName"
                    :key="item.name"
                    :item="item"
                    @clickHandler="clickCharacterCardHandler(item)"
                  />
                </template>
              </basis-list-wrapper>
            </div>
          </van-tab>
        </template>
      </van-tabs>
      <div class="fixed-bottom">
        <div class="service-wrapper" @click="clickServiceHandler">
          <basis-svg-icon class="kefu-icon" name="icon-nankefu" />
          <p class="title">客服</p>
        </div>
        <div class="button-wrapper">
          <template v-if="course.locked">
            <div class="button locked" @click="showVipList = true">
              <!-- <p class="title">开通VIP{{ course.vipNeeded.grade }}解锁该课程</p> -->
              <p class="title">开通VIP解锁该课程</p>
              <span class="tag">
                最低仅需
                <span v-money="vipsNeeded[0] && vipsNeeded[0].cashNeeded" />
                元
              </span>
            </div>
          </template>
          <template v-else>
            <div class="button unlocked" @click="showVipList = true">
              <p class="title">已解锁全部课程</p>
              <span class="tag">查看 VIP</span>
            </div>
          </template>
        </div>
      </div>
      <div class="popup-wrapper">
        <van-popup v-model="showService">
          <div class="service-wrapper">
            <p>请联系</p>
            <p>联系电话: {{ organization.mobile }}</p>
          </div>
        </van-popup>
        <vip-list-popup
          v-model="showVipList"
          :vips-needed="vipsNeeded"
        />
      </div>

      <service-popup
        v-model="showService"
        :service="organization.contactPerson"
      />
    </template>
  </div>
</template>

<script>
import { BasisNav, BasisCopyBookCard, BasisSvgIcon, BasisListWrapper } from '@/components/basis'
import VipListPopup from '@/components/VipListPopup'
import ServicePopup from '@/components/CustomerServicePopup'
import CharacterCard from './components/CharacterCard'
import LessonCard from './components/LessonCard'
import { mapGetters, mapActions } from 'vuex'
import { Course } from '@/api'
import { mixinWxShare } from '@/mixins'

export default {
  name: 'CoursesWrapper',
  components: { BasisNav, BasisCopyBookCard, BasisSvgIcon, VipListPopup, ServicePopup, CharacterCard, LessonCard, BasisListWrapper },
  mixins: [mixinWxShare],
  data: () => ({
    isRefresh: false,
    loading: true,
    onlyVideo: undefined,
    kw: '',
    tagOptions: {
      characters: {
        title: '单字精讲',
        componentName: 'character-card'
      },
      stages: {
        title: '课程目录',
        componentName: 'lesson-card'
      }
    },
    showVipList: false,
    showService: false,
    courseId: undefined,
    course: {
      locked: true,
      vipsNeeded: [],
      tags: []
    }
  }),
  computed: {
    ...mapGetters(['organization']),
    activeTab: {
      set (active) {
        return active
      },
      get () {
        return this.course.tags[0] || 'characters'
      }
    },
    tags () {
      return this.course.tags
    },
    extraKeys () {
      return {
        courseId: this.courseId,
        video: this.onlyVideo || undefined
      }
    },
    vipsNeeded () {
      return this.course.vipsNeeded
    }
  },
  mounted () {
    const { kw } = this.$route.query
    this.kw = kw
  },
  async activated () {
    try {
      const { id } = this.$route.params
      this.courseId = id
      const { course } = await Course.detail({ id })
      this.course = course
      this.updateCourse(course)
      this.updateTeacher(course.teacher)
      this.isRefresh = false
      this.loading = false
      this.onlyVideo = undefined
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    ...mapActions(['updateCourse', 'updateTeacher']),
    clickServiceHandler () {
      this.showService = true
    },
    clickCharacterCardHandler (item) {
      const { id: courseId, teacherId } = this.$route.params
      const { id } = item
      this.$router.push({
        name: 'character-id',
        params: {
          id,
          courseId,
          teacherId
        }
      })
    },
    onSearch (kw) {
      kw = kw.trim()
      this.kw = kw
      const { params, query } = this.$route
      this.$router.replace({
        params,
        query: {
          ...query,
          kw
        }
      })
    },
    back () {
      this.$router.push({
        name: 'teacher-courses'
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    const isRefreshName = ['teacher-courses']
    const isSavedPositionName = ['character-id', 'lesson-id']
    switch (true) {
      // HACK: 通过控制 isRefresh 来刷新 tags 的排序
      case isRefreshName.includes(to.name):
        this.isRefresh = true
        break
      case isSavedPositionName.includes(to.name):
        this.$route.meta.savedPosition = window.pageYOffset || window.scrollY
        break
    }
    next()
  }
}
</script>

<style scoped lang="scss">
.courses-wrapper {
  .basis-copy-book-card {
    padding: 16px;
  }
  .van-skeleton {
    ::v-deep {
      .van-skeleton__avatar {
        @include wh(100% !important, calc(343px * 2 / 3) !important);
        border-radius: 0;
      }
    }
    + .van-skeleton {
      margin-top: 10px;
    }
  }
  .van-tabs {
    ::v-deep {
      .van-tabs__wrap {
        border-radius: 0 0 8px 8px;
        &[class*='van-hairline']::after {
          display: none;
        }
        .van-tabs__line {
          @include wh(29px !important, 4px);
          @include lg-radius(#E6AC67, #F5C993);
          bottom: 20px;
          background-color: $color-text-active;
        }
      }
    }
    .wrapper {
      padding: 16px 16px 92px;
      &.characters::v-deep {
        .list {
          display: grid;
          grid-template-columns: repeat(5, minmax(60px, auto));
          grid-gap: 10px;
        }
      }
      &.stages {
        .lesson-card {
          + .lesson-card {
            margin-top: 20px;
          }
        }
      }
      .characters-features-wrapper {
        @include fj();
        vertical-align: middle;
        margin-bottom: 7px;
        .search-form {
          flex-grow: 1;
          .search-field {
            padding: 0;
            border-radius: 4px;
            background-color: #F2F3F5;
            &::after {
              border-bottom-color: transparent;
            }
            .icon-search {
              color: $color-text-light;
            }
          }
        }
        .toggole-button {
          flex-shrink: 0;
          padding: 0 7px;
          background-color: #F7F8FA;
          margin-left: 6px;
          ::v-deep {
            .van-checkbox__label--left {
              margin-right: 2px;
            }
          }
          .text {
            @include sc($font-size-md, #858383);
            @include lw(18px, 500);
            transition: color .2s ease;
            &.is-active {
              color: #E6AF6C;
            }
          }
        }
      }
    }
  }
  .fixed-bottom {
    @include bottomfix;
    @include wh(100%, 76px);
    @include flex(row);
    background-color: #fff;
    box-shadow: 0 20px 50px 10px #E9B576;
    .service-wrapper {
      padding: 12px 49px;
      .kefu-icon {
        @include sc(26px, $color-text-light);
      }
      .title {
        @include sc($font-size-lg, $color-text-light);
        @include lw(23px);
        margin-top: 4px;
      }
    }
    .button-wrapper {
      flex-grow: 1;
      padding: 8px 16px 8px 0;
      .button {
        @include wh(100%, 60px);
        color: #fff;
        padding: 8px 0;
        text-align: center;
        &.locked {
          @include lg-radius(#E6AC67, #F5C993);
        }
        &.unlocked {
          @include lg-radius(#D9D9D9, #A2A2A2);
        }
        .title {
          @include ft($font-size-xlg, 25px);
        }
        .tag {
          @include ft($font-size-base, 17px);
        }
        &:active {
          opacity: 0.8;
        }
      }
    }
  }
  .popup-wrapper {
    .service-wrapper {
      @include sc($font-size-lg, $color-text-heavy);
      padding: 40px;
      border-radius: 4px;
    }
  }
}
</style>
